import { Component } from '@verndale/core';
import { getRandomColor } from '../helpers';

class QuoteBlock extends Component {
  constructor(el: HTMLElement) {
    super(el);
    this.generateRandomColor();
  }

  generateRandomColor() {
    const randomColor = getRandomColor('dark');
    this.el.classList.add(`quote-block--${randomColor.name}`);
  }
}

export default QuoteBlock;
